export { default } from "./ListItemHeaderExpemplarCategoryHeading";
